/*
This function needs to be called before anything else is
loaded into the application, it contains processes that
are 100% independent of the application, but the application
may be dependent on them, an example would be the
use of a lib of polyfill
*/

import './lib/listen'
import React from 'react'
import { render } from 'react-dom'
import App from './components/core/App/App'
import appContainer from './container'
import './lib/analytics'

render(<App />, appContainer)
